import React, { useState } from "react";
import { Plus, Trash2, Building, Edit2, MapPin, Navigation } from 'lucide-react';
import SucursalEditModal from './SucursalEditModal';

export default function SucursalForm({
  sucursales,
  nuevaSucursal,
  setNuevaSucursal,
  agregarSucursal,
  eliminarSucursal,
  actualizarSucursal,
  clienteId
}) {
  const [mostrarModal, setMostrarModal] = useState(false);
  const [sucursalEditando, setSucursalEditando] = useState(null);
  const [indiceEditando, setIndiceEditando] = useState(-1);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      agregarSucursal();
    }
  };

  const abrirEdicion = (sucursal, index) => {
    setSucursalEditando(sucursal);
    setIndiceEditando(index);
    setMostrarModal(true);
  };

  const cerrarModal = () => {
    setMostrarModal(false);
    setSucursalEditando(null);
    setIndiceEditando(-1);
  };

  const guardarSucursal = (sucursalData, index) => {
    if (actualizarSucursal) {
      actualizarSucursal(sucursalData, index);
    }
    cerrarModal();
  };

  const getSucursalNombre = (sucursal) => {
    return typeof sucursal === 'string' ? sucursal : sucursal.nombre;
  };

  const getSucursalInfo = (sucursal) => {
    if (typeof sucursal === 'string') return null;
    return sucursal;
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Gestionar Sucursales
        </label>
        <div className="flex gap-2">
          <input
            type="text"
            className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            value={nuevaSucursal}
            onChange={(e) => setNuevaSucursal(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Nombre de la nueva sucursal"
          />
          <button
            type="button"
            onClick={agregarSucursal}
            disabled={!nuevaSucursal.trim()}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Agregar
          </button>
        </div>
      </div>

      {sucursales.length > 0 && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Sucursales Registradas ({sucursales.length})
          </label>
          <div className="space-y-2 max-h-96 overflow-y-auto">
            {sucursales.map((s, i) => {
              const info = getSucursalInfo(s);
              const nombre = getSucursalNombre(s);
              const tieneUbicacion = info?.coordenadas_lat && info?.coordenadas_lng;
              
              return (
                <div
                  key={i}
                  className="bg-white border border-gray-200 rounded-lg px-3 py-3 hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-start justify-between gap-2">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <Building className="w-4 h-4 text-gray-400 flex-shrink-0" />
                        <span className="text-sm font-medium text-gray-900 truncate">{nombre}</span>
                        {info?.ubicacion_remota && (
                          <span className="px-2 py-0.5 bg-orange-100 text-orange-700 text-xs rounded-full">
                            Remota
                          </span>
                        )}
                        {tieneUbicacion && (
                          <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full flex items-center gap-1">
                            <Navigation className="w-3 h-3" />
                            GPS
                          </span>
                        )}
                      </div>
                      {info && (
                        <div className="text-xs text-gray-600 space-y-0.5 ml-6">
                          {info.ubicacion_ciudad && (
                            <div className="flex items-center gap-1">
                              <MapPin className="w-3 h-3" />
                              {info.ubicacion_ciudad}
                              {info.distancia_km > 0 && ` (${info.distancia_km} km)`}
                            </div>
                          )}
                          {info.ubicacion_direccion && (
                            <div className="truncate">{info.ubicacion_direccion}</div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="flex items-center gap-1 flex-shrink-0">
                      <button
                        type="button"
                        onClick={() => abrirEdicion(s, i)}
                        className="p-1.5 text-emerald-600 hover:text-emerald-800 hover:bg-emerald-100 rounded transition-colors"
                        title="Editar sucursal"
                      >
                        <Edit2 className="w-4 h-4" />
                      </button>
                      <button
                        type="button"
                        onClick={() => eliminarSucursal(i)}
                        className="p-1.5 text-red-600 hover:text-red-800 hover:bg-red-100 rounded transition-colors"
                        title="Eliminar sucursal"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {sucursales.length === 0 && (
        <div className="text-center py-4 text-gray-500 text-sm">
          <Building className="w-8 h-8 text-gray-300 mx-auto mb-2" />
          No hay sucursales registradas
        </div>
      )}

      {/* Modal de edición */}
      {mostrarModal && (
        <SucursalEditModal
          sucursal={sucursalEditando}
          sucursalIndex={indiceEditando}
          clienteId={clienteId}
          onSave={guardarSucursal}
          onClose={cerrarModal}
        />
      )}
    </div>
  );
}
